import { kebabCase, startCase } from "lodash-es";

/** Converts an integration key to a display label, e.g. "foo-bar" -> "Foo Bar". */
export const startCased = (integration: string): string =>
  startCase(kebabCase(integration).replace("-", " "));

let labeller: (integration: string) => string = startCased;

/** Points {@link integrationLabelFor} at the real registry lookup.
 *
 * Called by `shared/src/integrations/registry.ts`, which cannot be imported
 * from here: `error.ts` is reachable from most of the codebase, so importing
 * the registry from it would make every consumer of a P0 error a registry
 * consumer.
 */
export const registerIntegrationLabeller = (
  impl: (integration: string) => string
): void => {
  labeller = impl;
};

/** An integration's display label, start-cased if nothing better is known —
 * the same fallback `integrationLabel` applies to an unknown key.
 */
export const integrationLabelFor = (integration: string): string =>
  labeller(integration);

/** A display label for a name callers pass as either an integration key
 * ("harbor", "cloud run") or a label already ("Docker Hub", "AWS").
 *
 * Keys are always lowercase, so a name with a capital letter is kept as is;
 * relabelling it would turn "AWS" into "Aws".
 */
export const displayLabelFor = (name: string): string =>
  /[A-Z]/.test(name) ? name : integrationLabelFor(name);
